export enum NotificationType {
    AGENCY = "Agencija",
    EMPLOYEE = "Zaposleni",
}

export interface Notification {
    id?: string;
    registrationId?: string;  //id prijave ili ucesnika
    isCompanyRegistration?: boolean;
    type: NotificationType; //obavestenje agenciji ili zaposlenom
    title: string;
    content: string;
    seen: boolean;
}
